import { createSlice } from '@reduxjs/toolkit';
import type { ModalsState } from 'src/types/modals';
import reducers from 'src/redux/modals/reducers';

const initialState: ModalsState = {
  imageSlidesModal: { isVisible: false, extraProps: {} },
  askQuestionModal: { isVisible: false, extraProps: {} },
  pausedNotesModal: { isVisible: false, extraProps: {} },
  descriptionHistoryModal: { isVisible: false, extraProps: {} },
  mapModal: { isVisible: false, extraProps: {} },
  maintenanceHistoryModal: { isVisible: false, extraProps: {} },
  invoicedRedirectModal: { isVisible: false, extraProps: {} },
  approveQuoteModal: { isVisible: false, extraProps: {} },
  materialModal: { isVisible: false, extraProps: {} },
  addonModal: { isVisible: false, extraProps: {} },
  needMoreTimeModal: { isVisible: false, extraProps: {} },
  rejectQuoteModal: { isVisible: false, extraProps: {} },
  reviseQuoteModal: { isVisible: false, extraProps: {} },
  quoteHistoryModal: { isVisible: false, extraProps: {} },
  hvacModal: { isVisible: false, extraProps: {} },
  escalationStatusModal: { isVisible: false, extraProps: {} },
  residentResponsibilityModal: { isVisible: false, extraProps: {} },
  residentResponsibilityRemoveModal: { isVisible: false, extraProps: {} },
};

const modals = createSlice({
  name: 'modals',
  initialState,
  reducers,
});

export const {
  updateVisibility,
} = modals.actions;

export default modals.reducer;
